<template>
  <el-card class="d-flex justify-content-center flex-column p-3 m-3">
    <p>{{ $t('checkout.binding_order') }}</p>
    <TabButtons v-model="type" :items="[$t('checkout.order'), $t('checkout.request')]" />
    <el-button type="primary" class="mt-4" @click="onNext">
      {{ $t('checkout.continue_as', { label: typeLabel }) }}
    </el-button>
  </el-card>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import TabButtons from '../../components/atoms/TabButtons';
import StoreModules from '../../store/store-modules';
export default {
  name: 'CheckoutTypePage',
  components: { TabButtons },
  props: {},
  mounted() {},
  destroyed() {},
  data() {
    return {
      type: 0,
    };
  },
  computed: {
    ...mapGetters(StoreModules.USER, ['language']),
    typeLabel() {
      if (this.type === 0) {
        if (this.language === 'en') return this.$t('checkout.order').toLowerCase();

        return this.$t('checkout.order');
      }
      if (this.language === 'en') return this.$t('checkout.request').toLowerCase();

      return this.$t('checkout.request');
    },
  },
  methods: {
    ...mapMutations(StoreModules.CHECKOUT, ['setCheckoutType']),
    onNext() {
      this.setCheckoutType(this.type === 0 ? 'Order' : 'Request');
      this.$router.push({ name: this.$routeNames.CHECKOUT_DETAILS_PAGE_ROUTE });
    },
  },
};
</script>

<style scoped>
.toogle-div {
  padding: 3em;
  border: 1px solid;
  margin: 0.3rem;
  border-radius: 15px;
}
</style>
